import * as externalTypes from './external-types.js';
export { externalTypes as ProductTypes };
export { default as FeaturedProducts } from './lib-components/FeaturedProducts/FeaturedProducts.js';
export { ProductListingGallery } from './lib-components/ProductListingGallery/ProductListingGallery.js';
export { ProductCatalogBreadcrumbs } from './lib-components/ProductCatalogBreadcrumbs/ProductCatalogBreadcrumbs.js';
export { ProductPromotions } from './lib-components/ProductPromotions/ProductPromotions.js';
import '@swc/helpers';
import 'react';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/content';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
export { RecommendationListContainer as ProductRecommendations } from './lib-components/RecommendedProducts/RecommendationListContainer.js';
export { default as RecentlyViewedProducts } from './lib-components/RecentlyViewedProducts/RecentlyViewedProducts.js';
export { ProductListing } from './ProductListing/ProductListing.js';
export { mapProductProjectionToListingProduct } from './ProductListing/mappers/listing-product/map-product-projection-to-listing-product.js';
import '@grandvisionhq/analytics';
export { createImpressionEvent, createInteractionEvent } from './DataLayer/Events/ProductPromotionEvents.js';
import '@grandvisionhq/fun-products';
export { useProductLink } from './utils/use-product-link.js';
//# sourceMappingURL=index.js.map
